import { environment } from './../environments/environment';

export class Utils {
    //static baseUrlOpenStack = 'https://kaabuv2.orangemali.local:32169/openstack';
    //static baseUrlOpenStack= 'https://applidistri.orangemali.com:32111/commandes';
    //static baseUrlOpenStack= 'http://localhost:3555/commandes';
    //static baseUrlOpenStack= 'https://applidistri.orangemali.com:32111/commandes'
    static newGalleryImage(img) {
        //const url = this.baseUrlOpenStack + '/afficher?nom-image=' + img + '&container=kyc_archives&type-fichier=image';
        //const url = this.baseUrlOpenStack + '/image?image=' + img;
        const url = environment.baseUrl + '/commandes/image?image=' + img;
        return { small: url, medium: url, big: url };
    }
}
